import * as styles from "./PopoverViewport.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";

import type { PopoverViewportProps } from "./Popover.types";

export function PopoverViewport({
  className,
  ...props
}: PopoverViewportProps): JSX.Element {
  return (
    <BasePopover.Viewport
      data-slot="popover-viewport"
      className={clsx(styles.viewport, className)}
      {...props}
    />
  );
}
